const admins_list_show = (state = [], action) => {
  switch (action.type) {
    case "admins_list_store":
      return action.payload;
    default:
      return state;
  }
};

export default admins_list_show;
